import { getJti } from '../../index'

function matchEnv(reg) {
  return reg.test(window.location.hostname)
}

//7上就是release
export function isReleaseEnv() {
  return matchEnv(/(m|www|admin)7.hunliji.com/i)
}
//线上master
export function isMasterEnv() {
  return matchEnv(/(m|www|admin).hunliji.com/i)
}

//测试环境test
export function isTestEnv() {
  return !(isMasterEnv() || isReleaseEnv())
}

export const getWebSocketUrl = () => {
  let webSocketUrl = ''
  let url = ''
  const isHttps = window.location.protocol.indexOf('https') > -1
  const port = isHttps ? 8011 : 8010
  const wsPort = isHttps ? 6051 : 6050
  const wsPrefix = isHttps ? 'wss' : 'ws'

  if (isMasterEnv()) {
    url = 'https://css.hunliji.com:8011'
    webSocketUrl = 'wss://comet.hunliji.com:6051/api/ws'
  } else if (isReleaseEnv()) {
    url = `//www7.hunliji.com:${port}`
    webSocketUrl = `${wsPrefix}://www7.hunliji.com:${wsPort}/api/ws`
  } else {
    url = `//test.hunliji.com:${port}`
    webSocketUrl = `${wsPrefix}://test.hunliji.com:${wsPort}/api/ws`
  }

  webSocketUrl = webSocketUrl + `?jti=${getJti()}`

  return {
    webSocketUrl,
    domain: url
  }
}
